module.exports = __webpack_public_path__ + "static/media/face-9.6fa378e6.jpg";